export default __webpack_public_path__ + "static/media/pencil_26.8c471aa1.svg";